/**
 * POLE KATEGORII Z PODPOWIADANIEM — pełna lista rozwijana, sterowana pisaniem.
 *
 * [polecenie właściciela 2026-09-12 wieczór]
 *  (5) „zró tak, żę sekcja kategoria w obsłudze zgłoszenia w szczególąc zgłoszenia można było coś
 *      wpisać i dynaimcznie pdopowie co wybrać."
 *  (6) „W szczegółach obsługi zgłoszeń, skoro tworzmyy kategorie i możliwość przypisania według
 *      takiego okna, to też powiedzmy w ładny sposób, wyświetlaj te lsitę by to zrobić dobrze"
 *
 * CO BYŁO ŹLE: kategoria była zwykłym `<select>` z `<optgroup>`. Przy kilkudziesięciu kategoriach
 * jedynym sposobem wyboru było przewijanie listy systemowej — bez szukania, bez ścieżki nadrzędnej
 * i bez informacji, z którego modułu kategoria pochodzi.
 *
 * DECYZJE, które z tego wynikły:
 *
 *  • NIE `<datalist>`. Wygląda jak skrót, ale: nie da się go ostylować, nie pokazuje grup ani
 *    plakietek, a w Safari bywa martwy. Dostajemy `role="combobox"` + `role="listbox"` ręcznie —
 *    razem z `aria-expanded`, `aria-activedescendant` i obsługą klawiatury, których `<datalist>`
 *    nie daje w sposób przewidywalny.
 *
 *  • SZUKAMY BEZ OGONKÓW I BEZ WIELKOŚCI LITER. „drukarki" ma znaleźć „Drukarki", a „zgloszenie"
 *    — „Zgłoszenie". Polski agent nie będzie przełączał się na ogonki w polu wyszukiwania.
 *    Dopasowanie działa TAKŻE po nazwie grupy nadrzędnej: wpisanie „sprzęt" pokazuje wszystko,
 *    co pod sprzętem stoi, choć w nazwie liścia tego słowa nie ma.
 *
 *  • LISTA NIE ZNIKA PRZY PUSTYM POLU. Kliknięcie w pole pokazuje PEŁNĄ listę pogrupowaną —
 *    to jest ta „ładnie wyświetlona lista", o którą prosi punkt 6. Podpowiadanie ma ją zawężać,
 *    a nie zastępować.
 *
 *  • ESCAPE COFA, a nie czyści. Po Escape w polu wraca nazwa AKTUALNIE wybranej kategorii —
 *    inaczej jedno nieuważne naciśnięcie kasowałoby klasyfikację sprawy. Wybór zmienia się
 *    wyłącznie przez Enter na podświetlonej pozycji, kliknięcie albo jawne „wyczyść".
 *
 *  • WYJŚCIE Z POLA (blur) NIE WYBIERA NICZEGO. Wpisany, niedokończony tekst znika i wraca nazwa
 *    wybranej kategorii. Zgadywanie („pewnie chodziło o pierwszą pasującą") to najkrótsza droga do
 *    zgłoszenia zaklasyfikowanego przypadkiem.
 *
 * ⚠ Komponent NIE ma stanu prawdy o kategorii — trzyma tylko tekst w polu. Wartością rządzi karta
 * zgłoszenia (`classCategoryId`), bo to ona liczy `classDirty` i wysyła zapis. Drugi stan prawdy
 * rozjechałby przycisk „Zapisz".
 *
 * ────────────────────────────────────────────────────────────────────────────────────────────
 * [polecenie właściciela 2026-09-15] „zrób tą listę trochę większą, np. do 15 pozycji
 * wyświetlanych (…) rób to dynamicznie, jak będzie dużo krótsza to krótsza, ale powinna stanowić
 * po rozwinięciu 3/4 wysokości okna przeglądarki”.
 *
 * CO BYŁO ŹLE: sufit siedział w CSS na sztywno (`max-height: 17rem` ≈ 5-6 pozycji) — i nie dało
 * się go po prostu podnieść. Lista była `position: absolute` w `.sidebar` karty zgłoszenia, a ten
 * panel ma `overflow-y: auto`: wszystko poniżej jego dolnej krawędzi było PRZYCINANE, a reszta
 * wpadała w przewijanie panelu (dwa przewijaki jeden w drugim; strzałka w dół wywoziła pole
 * wyszukiwania poza widok). Sufit 75vh wpisany w CSS dałby więc listę uciętą, tylko wyżej.
 *
 * DECYZJE:
 *  • LISTA IDZIE W PORTAL do <body>. To jedyny sposób wyjścia spod TRZECH przycinających
 *    przodków (`.sidebar` overflow-y:auto → `.modalBodyLayout` overflow:hidden →
 *    `.modalBodyWrapper` overflow-y:auto) ORAZ spod `transform: translateX(0)`, który `.sidebar`
 *    dostaje poniżej 1024 px — niezerowy transform czyni z przodka blok zawierający dla
 *    `position: fixed`, więc samo `fixed` bez portalu naprawiłoby desktop i zepsuło tablet.
 *  • WSPÓŁRZĘDNE I SUFIT LICZY `hooks/usePopoverPosition` — ten sam, którym stoi kalendarz dwa
 *    pola niżej w tym samym panelu. Nic tu nie piszemy od zera: hook mierzy treść przed
 *    malowaniem, daje `maxHeight` z REALNIE wolnego miejsca (czyli „krótka lista = krótkie
 *    okienko”, bo `max-height` nigdy nie rozciąga pudełka) i ODBIJA LISTĘ W GÓRĘ, gdy pole stoi
 *    nisko. To ostatnie jest konieczne, bo ten sam komponent stoi w połowie długiego formularza
 *    w oknie „+ Nowe zgłoszenie” — lista na 3/4 ekranu rozwijana zawsze w dół zasłoniłaby stopkę.
 *  • SUFIT = min(75vh, wolne miejsce przy polu) — `sufitUlamekOkna: 0.75`. Wyliczenie „ile to
 *    15 pozycji” (≈ 750 px przy 15 pozycjach dwuwierszowych i 3 nagłówkach grup) stoi
 *    w PoleKategorii.module.css przy regule `.lista`.
 *  • SZEROKOŚĆ MIERZYMY. Po portalu nie ma już `left: 0; right: 0`, a panel karty jest
 *    przeciągalny (`--szerokosc-panelu`), więc szerokości nie da się wpisać na sztywno.
 *  • KLIK W LISTĘ TO KLIK „WEWNĄTRZ”. Lista nie jest już potomkiem obudowy w DOM, więc warunek
 *    zamykania klikiem poza pole musi pytać też o nią (patrz `pozaObudowa`).
 */
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { FiChevronDown, FiSearch, FiX } from "react-icons/fi";
import usePopoverPosition from "../../../hooks/usePopoverPosition";
import useSzerokoscElementu from "../../../hooks/useSzerokoscElementu";
import styles from "./PoleKategorii.module.css";

/** Tekst do porównań: bez wielkości liter i bez znaków diakrytycznych. */
export const doPorownania = (tekst) =>
    String(tekst ?? "")
        .toLocaleLowerCase("pl-PL")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/ł/g, "l"); // „ł” nie rozkłada się przez NFD — trzeba osobno

/**
 * Płaska lista pozycji do wyboru, w kolejności wyświetlania, z nazwą grupy przy każdej.
 * `drzewo` to `categoryTree` z karty: `{ grouped: [{ group, leaves }], orphans: [] }`.
 */
export const spluszczDrzewo = (drzewo) => {
    const wynik = [];
    /* [S1 2026-09-14] `wybieralna` = OKNO BEZ KATEGORII (drzewoKategoriiZgloszenia.js): sekcja jest jednocześnie
       jedyną pozycją do wyboru, więc nie rysujemy nad nią osobnego nagłówka ani ścieżki „Okno › Okno”. */
    (drzewo?.grouped || []).forEach(({ group, leaves, wybieralna }) => {
        (leaves || []).forEach((liść) => wynik.push({
            ...liść, grupaNazwa: group?.name || "", grupaId: group?.id, sekcjaWybieralna: !!wybieralna,
        }));
    });
    (drzewo?.orphans || []).forEach((liść) => wynik.push({ ...liść, grupaNazwa: "", grupaId: null }));
    return wynik;
};

/** Filtr: pusty tekst = wszystko; inaczej dopasowanie po nazwie kategorii LUB nazwie grupy. */
export const przefiltruj = (pozycje, tekst) => {
    const igla = doPorownania(tekst).trim();
    if (!igla) return pozycje;
    return pozycje.filter(
        (p) => doPorownania(p.name).includes(igla) || doPorownania(p.grupaNazwa).includes(igla)
    );
};

/** Pozycje pogrupowane do renderowania (kolejność grup zachowana, „Inne" na końcu). */
export const pogrupuj = (pozycje) => {
    const grupy = [];
    pozycje.forEach((p) => {
        const klucz = p.grupaId || "__inne__";
        let g = grupy.find((x) => x.klucz === klucz);
        if (!g) {
            g = { klucz, nazwa: p.grupaNazwa || "Inne", pozycje: [], wybieralna: !!p.sekcjaWybieralna };
            grupy.push(g);
        }
        g.pozycje.push(p);
    });
    return grupy;
};

const PoleKategorii = ({
    wartosc = "",
    onZmiana,
    drzewo = null,
    zablokowane = false,
    moduly = [],
    idPola = "classCategory",
    /* [S25 2026-09-14] Okno nowego zgłoszenia pokazuje kategorie JEDNEGO modułu — plakietka byłaby szumem,
       a bez słownika modułów pokazałaby surowy kod. */
    pokazModul = true,
    /* [poprawki DZ-8 2026-10-03] Napis w pustym polu, gdy zgłoszenie MA kategorię, ale spoza listy (kategoria z innego modułu
       niż skrzynka) — zamiast „— Brak —”, które mówiło nieprawdę o klasyfikacji sprawy. */
    podpowiedzPusta = null,
}) => {
    const wszystkie = useMemo(() => spluszczDrzewo(drzewo), [drzewo]);
    const wybrana = useMemo(
        () => wszystkie.find((p) => String(p.id) === String(wartosc)) || null,
        [wszystkie, wartosc]
    );

    const [otwarta, setOtwarta] = useState(false);
    const [szukaj, setSzukaj] = useState("");
    const [podswietlony, setPodswietlony] = useState(0);
    const polaRef = useRef(null);
    const listaRef = useRef(null);
    const obudowaRef = useRef(null);
    // Kotwicą jest CAŁY wiersz pola (ramka z lupką i strzałką), a nie sam `<input>` —
    // lista ma stanąć pod ramką i mieć jej szerokość.
    const wierszRef = useRef(null);
    const [ustawWiersz, szerokoscPola] = useSzerokoscElementu(wierszRef, { pomiar: "outer" });
    /* 0.75 = „3/4 wysokości okna przeglądarki” wprost z polecenia; hook bierze MNIEJSZĄ z dwóch
       liczb: ten sufit i wolne miejsce przy polu. `minHeight` to podłoga dla sytuacji, w której
       pole stoi dokładnie przy krawędzi — lista woli wtedy wystawać na 180 px niż zniknąć. */
    const { style: stylListy } = usePopoverPosition(otwarta, wierszRef, listaRef, {
        fit: true,
        minHeight: 180,
        sufitUlamekOkna: 0.75,
    });

    /* Tekst w polu: przy zamkniętej liście to NAZWA wybranej kategorii, przy otwartej — to, co
       człowiek napisał. Dzięki temu zamknięte pole zawsze mówi prawdę o klasyfikacji sprawy. */
    const tekstPola = otwarta ? szukaj : (wybrana ? wybrana.name : "");

    const widoczne = useMemo(
        () => przefiltruj(wszystkie, otwarta ? szukaj : ""),
        [wszystkie, otwarta, szukaj]
    );
    const grupy = useMemo(() => pogrupuj(widoczne), [widoczne]);

    const nazwaModulu = useCallback(
        (kod) => {
            if (!kod) return null;
            const m = (moduly || []).find(
                (x) => String(x.code || x.moduleCode || "").toLowerCase() === String(kod).toLowerCase()
            );
            return m?.name || kod;
        },
        [moduly]
    );

    // Podświetlenie zawsze w zakresie widocznej listy — inaczej Enter wybrałby pozycję spoza niej.
    useEffect(() => {
        setPodswietlony((i) => (widoczne.length === 0 ? 0 : Math.min(i, widoczne.length - 1)));
    }, [widoczne.length]);

    const zamknij = useCallback(() => {
        setOtwarta(false);
        setSzukaj("");
    }, []);

    const otworz = useCallback(() => {
        if (zablokowane) return;
        setOtwarta(true);
        setSzukaj("");
        // Podświetlamy aktualny wybór, żeby strzałka w dół nie startowała od początku listy.
        const i = wszystkie.findIndex((p) => String(p.id) === String(wartosc));
        setPodswietlony(i >= 0 ? i : 0);
    }, [zablokowane, wszystkie, wartosc]);

    const wybierz = useCallback(
        (pozycja) => {
            if (onZmiana) onZmiana(pozycja ? String(pozycja.id) : "");
            zamknij();
        },
        [onZmiana, zamknij]
    );

    const klawisz = (e) => {
        if (zablokowane) return;
        if (e.key === "ArrowDown") {
            e.preventDefault();
            if (!otwarta) { otworz(); return; }
            setPodswietlony((i) => (widoczne.length ? (i + 1) % widoczne.length : 0));
        } else if (e.key === "ArrowUp") {
            e.preventDefault();
            if (!otwarta) { otworz(); return; }
            setPodswietlony((i) => (widoczne.length ? (i - 1 + widoczne.length) % widoczne.length : 0));
        } else if (e.key === "Home" && otwarta) {
            e.preventDefault();
            setPodswietlony(0);
        } else if (e.key === "End" && otwarta) {
            e.preventDefault();
            setPodswietlony(Math.max(0, widoczne.length - 1));
        } else if (e.key === "Enter") {
            if (!otwarta) return;
            e.preventDefault();
            const p = widoczne[podswietlony];
            if (p) wybierz(p);
        } else if (e.key === "Escape") {
            if (!otwarta) return;
            // Escape COFA — patrz nagłówek pliku. Zdarzenie zatrzymujemy, żeby nie zamknęło karty.
            e.preventDefault();
            e.stopPropagation();
            zamknij();
        } else if (e.key === "Tab") {
            zamknij();
        }
    };

    // Przewijanie listy za podświetleniem — pozycja wybrana klawiaturą musi być widoczna.
    useEffect(() => {
        if (!otwarta || !listaRef.current) return;
        const el = listaRef.current.querySelector('[data-podswietlona="tak"]');
        if (el && typeof el.scrollIntoView === "function") {
            el.scrollIntoView({ block: "nearest" });
        }
    }, [otwarta, podswietlony]);

    // Klik poza obudową zamyka listę (bez wybierania czegokolwiek).
    useEffect(() => {
        if (!otwarta) return undefined;
        const pozaObudowa = (e) => {
            if (!obudowaRef.current) return;
            if (obudowaRef.current.contains(e.target)) return;
            // ⚠ Lista stoi w PORTALU do <body>, więc DOM-owo nie jest już w obudowie. Bez tego
            // warunku klik w nagłówek grupy albo w pasek przewijania listy liczyłby się jako
            // „klik poza polem" i zamykał listę w trakcie wybierania.
            if (listaRef.current && listaRef.current.contains(e.target)) return;
            zamknij();
        };
        document.addEventListener("mousedown", pozaObudowa);
        return () => document.removeEventListener("mousedown", pozaObudowa);
    }, [otwarta, zamknij]);

    const idListy = `${idPola}-lista`;
    const idOpcji = (i) => `${idPola}-opcja-${i}`;
    let numer = -1; // numeracja przez wszystkie grupy — `aria-activedescendant` musi być globalne

    return (
        <div className={styles.obudowa} ref={obudowaRef} data-pole-kategorii>
            <div className={styles.wierszPola} ref={ustawWiersz} data-wiersz-kategorii>
                <FiSearch className={styles.ikonaSzukania} aria-hidden="true" />
                <input
                    ref={polaRef}
                    id={idPola}
                    type="text"
                    className={styles.pole}
                    role="combobox"
                    aria-expanded={otwarta}
                    aria-controls={idListy}
                    aria-autocomplete="list"
                    aria-haspopup="listbox"
                    aria-activedescendant={otwarta && widoczne.length ? idOpcji(podswietlony) : undefined}
                    autoComplete="off"
                    disabled={zablokowane}
                    placeholder={wybrana ? wybrana.name : (podpowiedzPusta || "— Brak — wpisz, żeby wyszukać")}
                    value={tekstPola}
                    onChange={(e) => { setOtwarta(true); setSzukaj(e.target.value); setPodswietlony(0); }}
                    onFocus={otworz}
                    onClick={otworz}
                    onKeyDown={klawisz}
                />
                {wybrana && !zablokowane && (
                    <button
                        type="button"
                        className={styles.wyczysc}
                        onClick={() => { wybierz(null); }}
                        title="Wyczyść kategorię (— Brak —)"
                        aria-label="Wyczyść kategorię"
                        data-wyczysc-kategorie
                    >
                        <FiX size={13} aria-hidden="true" />
                    </button>
                )}
                <FiChevronDown className={styles.strzalka} aria-hidden="true" />
            </div>

            {otwarta && createPortal(
                <div
                    className={styles.lista}
                    ref={listaRef}
                    /* `stylListy` z hooka: position/top/left, `maxHeight` = min(75vh, wolne miejsce)
                       i `visibility: hidden` do czasu pomiaru (lista nie mignie w rogu ekranu).
                       Szerokość dokładamy z pomiaru kotwicy — hook jej nie zwraca, a po wyjściu
                       z obudowy nie ma już `left: 0; right: 0`, które ją dawniej rozciągało. */
                    style={szerokoscPola ? { ...stylListy, width: szerokoscPola } : stylListy}
                    data-lista-kategorii
                >
                    <ul id={idListy} role="listbox" aria-label="Kategorie" className={styles.listaUl}>
                        {grupy.length === 0 && (
                            <li className={styles.pusto} role="presentation" data-brak-wynikow>
                                Nic nie pasuje do „{szukaj}". Skasuj część wpisu albo wyczyść pole.
                            </li>
                        )}
                        {grupy.map((g) => (
                            <li key={g.klucz} role="presentation" className={styles.grupa}>
                                {/* Nagłówek grupy jest OPISEM, nie pozycją — `role="presentation"`,
                                    żeby czytnik ekranu nie liczył go jako wybieralnej kategorii.
                                    [S1 2026-09-14] Okno BEZ kategorii nie ma nagłówka: samo jest pozycją
                                    (typem sprawy) i wygląda jak sekcja, żeby lista czytała się „sekcja → pozycje”. */}
                                {!g.wybieralna && <div className={styles.grupaNazwa} data-grupa={g.nazwa}>{g.nazwa}</div>}
                                <ul role="group" aria-label={g.nazwa} className={styles.listaUl}>
                                    {g.pozycje.map((p) => {
                                        numer += 1;
                                        const mojNumer = numer;
                                        const wybranaTa = String(p.id) === String(wartosc);
                                        // Kategoria okna ma pusty moduł i dziedziczy go po oknie (`modulEfektywny`).
                                        const kodModulu = p.modulEfektywny || p.module;
                                        const modul = pokazModul ? nazwaModulu(kodModulu) : null;
                                        return (
                                            <li
                                                key={p.id}
                                                id={idOpcji(mojNumer)}
                                                role="option"
                                                aria-selected={wybranaTa}
                                                data-podswietlona={mojNumer === podswietlony ? "tak" : "nie"}
                                                data-kategoria={p.id}
                                                data-sekcja-wybieralna={g.wybieralna ? "tak" : undefined}
                                                /* [polecenie właściciela 2026-09-14] „lista w sekcji podglądu zgłoszeń miała
                                                   wcięcia widoczne dla kategorii w danej grupie” — pozycja pod nagłówkiem
                                                   grupy dostaje wcięcie i łącznik drzewa (CSS po tym atrybucie). */
                                                data-wciecie={g.nazwa && g.klucz !== "__inne__" && !g.wybieralna ? "tak" : undefined}
                                                className={`${styles.opcja} ${g.wybieralna ? styles.opcjaSekcja : ""} ${mojNumer === podswietlony ? styles.opcjaPodswietlona : ""} ${wybranaTa ? styles.opcjaWybrana : ""}`}
                                                /* `onMouseDown` zamiast `onClick`: klik w pozycję nie może najpierw
                                                   zabrać fokusu polu (blur zamknąłby listę przed wyborem). */
                                                onMouseDown={(e) => { e.preventDefault(); wybierz(p); }}
                                                onMouseEnter={() => setPodswietlony(mojNumer)}
                                            >
                                                <span className={styles.opcjaNazwa}>{p.name}</span>
                                                {p.podpowiedz ? (
                                                    <span className={styles.podpowiedz} data-podpowiedz-kategorii>{p.podpowiedz}</span>
                                                ) : g.nazwa && g.klucz !== "__inne__" && !g.wybieralna && (
                                                    <span className={styles.sciezka} title={`Kategoria nadrzędna: ${g.nazwa}`}>
                                                        {g.nazwa} › {p.name}
                                                    </span>
                                                )}
                                                {modul && (
                                                    <span className={styles.plakietkaModulu} data-modul={kodModulu}>
                                                        {modul}
                                                    </span>
                                                )}
                                            </li>
                                        );
                                    })}
                                </ul>
                            </li>
                        ))}
                    </ul>
                </div>,
                document.body
            )}
        </div>
    );
};

export default PoleKategorii;
